import {
  useListOwnerPortalDistributions,
  type OwnerTransactionOut,
} from '@myrentalmate/api-client';
import { Alert, Stack, Typography } from '@mui/material';

import { DataTable, type DataColumn } from '../../components/DataTable';
import { TablePager, useTablePage } from '../../components/TablePager';
import { okItems } from '../../lib/apiData';
import { formatDate, formatMoney } from '../../lib/format';
import { OwnerNotLinked } from './OwnerNotLinked';
import { useOwnerHome } from './useOwnerHome';

const COLUMNS: DataColumn<OwnerTransactionOut>[] = [
  { label: 'Date', render: (t) => formatDate(t.paid_on) },
  { label: 'Property', render: (t) => t.property_name },
  {
    label: 'Type',
    render: (t) => (t.kind === 'distribution' ? 'Paid to You' : 'Received From You'),
  },
  { label: 'Reference', render: (t) => t.reference ?? '–' },
  { label: 'Amount', align: 'right', render: (t) => formatMoney(t.amount) },
];

export function OwnerDistributionsPage() {
  const { notLinked } = useOwnerHome();
  const rows = okItems(useListOwnerPortalDistributions({ query: { retry: false } }).data);
  const paging = useTablePage();
  if (notLinked) return <OwnerNotLinked />;
  const showing = rows.slice(paging.page * paging.pageSize, (paging.page + 1) * paging.pageSize);
  return (
    <Stack spacing={2}>
      <Typography variant="h5">Distributions</Typography>
      <DataTable columns={COLUMNS} rows={showing} rowKey={(t) => t.id} />
      <TablePager paging={paging} total={rows.length} />
      {rows.length === 0 && <Alert severity="info">Nothing has been recorded yet.</Alert>}
    </Stack>
  );
}
